import React, { useState } from 'react';

// Someone from the owner's advisor's network, suggested for an empty seat
// before the marketplace (Succeedo Phase 5, PRD §5-3). Adding them puts
// them on the owner's team; the owner contacts them directly.
export default function NetworkSuggestion({ contact, advisorName, onAdd, compact = false }) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  if (!contact) return null;

  const add = async () => {
    setBusy(true);
    setError('');
    try {
      await onAdd(contact.id);
    } catch (e) {
      setError(e?.message || 'Could not add. Please try again.');
      setBusy(false);
    }
  };

  return (
    <div
      className={`w-full rounded-xl border border-[hsl(var(--succeedo-orange))]/30 bg-[hsl(var(--succeedo-orange))]/5 ${compact ? 'p-2' : 'p-3'} text-left`}
      data-testid="network-suggestion"
    >
      <span className="block font-mono text-[9px] uppercase tracking-wide text-muted-foreground">
        Suggested by {advisorName}
      </span>
      <span className="block text-[13px] font-medium text-foreground truncate" title={contact.name}>{contact.name}</span>
      {contact.firm && <span className="block text-[12px] text-muted-foreground truncate">{contact.firm}</span>}
      {!compact && contact.note && <span className="block text-[12px] text-muted-foreground mt-0.5">{contact.note}</span>}
      <button
        type="button"
        disabled={busy || !onAdd}
        onClick={add}
        className="mt-1.5 text-[12px] font-medium text-[hsl(var(--succeedo-orange))] hover:underline disabled:opacity-60"
        data-testid={`network-add-${contact.id}`}
      >
        {busy ? 'Adding…' : 'Add to my team'}
      </button>
      {error && <span className="block text-[11px] text-coral-ink mt-1">{error}</span>}
    </div>
  );
}
